module.exports = __webpack_public_path__ + "first-20-watermark.jpg?1ac9da20a104a5ae275ac79761a1ce73";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20-watermark.jpg
// module id = 467
// module chunks = 0